import { skipToken, useQuery } from "@tanstack/react-query";
import React from "react";
import { API2Context } from "@/utils/api2";

export function useIsPeerFeedbackEnabled(organizationId: string | undefined) {
	const api = React.useContext(API2Context);
	const { data, isPending } = useQuery({
		queryKey: ["isPeerFeedbackEnabled", organizationId],
		queryFn: organizationId
			? () =>
					api
						.get<{ enabled: true }>(
							`/v1/org/${organizationId}/peer-feedbacks/is-enabled`,
						)
						.then((res) => res.data.enabled)
			: skipToken,
	});

	return {
		isEnabled: data ?? false,
		isPending,
	};
}
